import axios from 'axios';

const axiosinstance = axios.create({
 // baseURL: 'http://localhost:8000',
  //baseURL: "http://172.105.253.129:8000",
baseURL: "https://backend.uplsnipe.com",
  withCredentials: true
});

axiosinstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosinstance;


